export const PROJECT_TYPES = {
  Digital: 'DIGITAL',
  ConceptTest: 'CONCEPT_TEST',
  Physical: 'IHUT',
} as const;

export const PROJECT_SUBTYPES = {
  NonStimulus: 'non_stimulus',
} as const;

export const PROJECT_TYPE_LABELS = {
  [PROJECT_TYPES.Digital]: 'Digital Test',
  [PROJECT_TYPES.ConceptTest]: 'Digital Test',
  [PROJECT_TYPES.Physical]: 'IHUT',
} as const;

export const EXPERIENCE_TYPES = {
  New: 'new', // Productized solutions
  Old: 'old',
} as const;

export const EXPERIENCE_TYPE_LABELS = {
  [EXPERIENCE_TYPES.New]: 'Platform',
  [EXPERIENCE_TYPES.Old]: 'Legacy',
} as const;
